module.exports = __webpack_public_path__ + "media/components/assets/img/bg/footer-bottom-right-flyo-577db79cd850c74f3cd93dc4b1eafaf2.svg";